(function () {
  var CARD = '.grid-product, .grid__item';

  function primaryImg(card) {
    var imgs = card.querySelectorAll('.grid-product__image-mask img, .grid__image-ratio img');
    for (var i = 0; i < imgs.length; i++) {
      if (!imgs[i].closest('.grid-product__secondary-image, .grid-product__color-image')) return imgs[i];
    }
    return null;
  }
  function remember(img) {
    if (img.dataset.dcOrigSrc) return;
    img.dataset.dcOrigSrc = img.currentSrc || img.src;
    img.dataset.dcOrigSrcset = img.getAttribute('srcset') || '';
  }
  function showImage(card, sw) {
    var img = primaryImg(card);
    if (!img || !sw.dataset.src) return;
    remember(img);
    img.removeAttribute('loading');
    if (sw.dataset.srcset) img.setAttribute('srcset', sw.dataset.srcset);
    img.src = sw.dataset.src;
    card.classList.add('dc-preview');
  }
  function restore(card) {
    var chosen = card.querySelector('.dc-sw[data-dc-chosen]');
    if (chosen) { showImage(card, chosen); return; }
    var img = primaryImg(card);
    if (img && img.dataset.dcOrigSrc) {
      if (img.dataset.dcOrigSrcset) img.setAttribute('srcset', img.dataset.dcOrigSrcset);
      else img.removeAttribute('srcset');
      img.src = img.dataset.dcOrigSrc;
    }
    card.classList.remove('dc-preview');
  }
  function select(sw) {
    var card = sw.closest(CARD);
    if (!card) return;
    card.querySelectorAll('.dc-sw').forEach(function (s) {
      s.classList.remove('is-selected');
      s.removeAttribute('data-dc-chosen');
      s.setAttribute('aria-pressed', 'false');
    });
    sw.classList.add('is-selected');
    sw.setAttribute('data-dc-chosen', '');
    sw.setAttribute('aria-pressed', 'true');
    showImage(card, sw);
    if (sw.dataset.url) {
      card.querySelectorAll('a[href*="/products/"]').forEach(function (a) { a.href = sw.dataset.url; });
    }
  }

  document.addEventListener('click', function (e) {
    var sw = e.target.closest('.dc-sw');
    if (!sw) return;
    e.preventDefault();
    e.stopPropagation();
    select(sw);
  }, true);
  document.addEventListener('keydown', function (e) {
    var sw = e.target.closest && e.target.closest('.dc-sw');
    if (!sw || (e.key !== 'Enter' && e.key !== ' ')) return;
    e.preventDefault();
    select(sw);
  });
  document.addEventListener('pointerover', function (e) {
    if (e.pointerType !== 'mouse') return;
    var sw = e.target.closest('.dc-sw');
    if (!sw) return;
    var card = sw.closest(CARD);
    if (card) showImage(card, sw);
  });
  document.addEventListener('pointerout', function (e) {
    if (e.pointerType !== 'mouse') return;
    var row = e.target.closest('.dc-sw-row');
    if (!row || (e.relatedTarget && row.contains(e.relatedTarget))) return;
    var card = row.closest(CARD);
    if (card) restore(card);
  });

  function check(wrap) {
    var row = wrap.querySelector('.dc-sw-row');
    if (!row) return;
    var over = row.scrollWidth > row.clientWidth + 1;
    wrap.classList.toggle('is-overflowing', over);
    wrap.classList.toggle('is-at-end', row.scrollLeft + row.clientWidth >= row.scrollWidth - 2);
  }
  function checkAll() { document.querySelectorAll('.dc-sw-wrap').forEach(check); }
  document.addEventListener('scroll', function (e) {
    if (e.target.classList && e.target.classList.contains('dc-sw-row')) check(e.target.parentElement);
  }, true);
  var t;
  function debounced() { clearTimeout(t); t = setTimeout(checkAll, 150); }
  window.addEventListener('resize', debounced);
  window.addEventListener('load', checkAll);
  document.addEventListener('DOMContentLoaded', checkAll);
  if (document.readyState !== 'loading') checkAll();
  if ('MutationObserver' in window) {
    new MutationObserver(debounced).observe(document.documentElement, { childList: true, subtree: true });
  }
})();